// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isCanada, getIconPath } from '@tcp/core/src/utils';
import {
  getContactFormValuesFromSS,
  setContactFormValuesInSS,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import GlobalFormValidationLabels, {
  GLOBAL_FORM_VALIDATION_LABELS,
} from '@tcp/core/src/utils/labels/globalFormValidation.labels';
import Notification from '../../../../../../common/molecules/Notification';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/CreateAccounPage.style';
import CreateAccountFormV2 from '../../../molecules/CreateAccountForm/views/CreateAccountFormV2';
import PasswordRequirement from '../../../../ResetPassword/molecules/PasswordRequirement';
import CreateAccountSkeleton from '../../../molecules/skeleton/CreateAccountSkeleton.view';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  myPlaceRewards,
  GlobalAccessibilityLabels,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '../../../../../../../utils/labels/globalLogin.labels';
import {
  GLOBAL_REGISTRATION_LABELS,
  GlobalRegistrationLabels,
} from '../../../../../../../utils/labels/globalRegistrations.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblCreateAccount,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import CreateAccountOtpForm from '../../../../LoginPage/molecules/CreateAccountOtpForm';

class CreateAccounPage extends React.Component {
  static propTypes = {
    createAccountAction: PropTypes.func,
    className: PropTypes.string,
    isIAgreeChecked: PropTypes.bool,
    hideShowPwd: PropTypes.bool,
    confirmHideShowPwd: PropTypes.bool,
    error: PropTypes.string,
    onAlreadyHaveAnAccountClick: PropTypes.func,
    showForgotPasswordForm: PropTypes.func,
    isUserLoggedIn: PropTypes.bool.isRequired,
    userplccCardNumber: PropTypes.string.isRequired,
    userplccCardId: PropTypes.string.isRequired,
    closeOverlay: PropTypes.func,
    isResetPassCodeValidationEnabled: PropTypes.bool.isRequired,
    existingUserInformation: PropTypes.shape({}),
    fullPageView: PropTypes.bool,
    formSubmissionTriggered: PropTypes.bool,
    showSkeleton: PropTypes.bool,
    isSafari: PropTypes.bool,
  };

  static defaultProps = {
    createAccountAction: () => {},
    className: '',
    isIAgreeChecked: false,
    hideShowPwd: false,
    confirmHideShowPwd: false,
    error: {},
    onAlreadyHaveAnAccountClick: () => {},
    showForgotPasswordForm: () => {},
    closeOverlay: () => {},
    existingUserInformation: {},
    fullPageView: false,
    formSubmissionTriggered: false,
    showSkeleton: false,
  };

  constructor(props) {
    super(props);
    this.parentRef = React.createRef();
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.renderHeaderBrands = this.renderHeaderBrands.bind(this);
    this.handleSubmitCalled = false;
    this.formValidationErrorLabels = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_FORM_VALIDATION_LABELS}`,
      GlobalFormValidationLabels
    );
    this.state = {
      newCodeSent: false,
    };
  }

  componentDidMount() {
    const { showSkeleton, loginFlowUXEnhancementEnabled } = this.props;
    if (this.parentRef && !showSkeleton && !loginFlowUXEnhancementEnabled) {
      setTimeout(() => {
        this.parentRef.current.scrollIntoView();
      }, 500);
    } else {
      window?.scrollTo(0, 0);
    }
    // adding 500 to test on safari
  }

  componentDidUpdate(prevProps) {
    const {
      isUserLoggedIn,
      isShowOTPInputScreen,
      isOTpScreenEnabled,
      error,
      existingUserResponse,
    } = this.props;
    const container = document.getElementById('dialogContent');
    const userLoggedIn = !prevProps.isUserLoggedIn && isUserLoggedIn;
    const errorTriggered = error && !prevProps.error;
    const { emailAddress } = existingUserResponse || {};
    const updatedContactFormValues = {
      isCreateAccountOtpScreen: true,
      emailAddress,
      isNewUser: true,
    };
    // Scrolling up to see the success end error message
    if ((userLoggedIn || errorTriggered) && container) {
      container.scrollTo(0, 0);
    }

    if ((userLoggedIn || errorTriggered) && this.parentRef) {
      this.parentRef.current.scrollIntoView();
    }
    if (
      isShowOTPInputScreen &&
      isOTpScreenEnabled &&
      !error &&
      existingUserResponse?.emailAddress &&
      !existingUserResponse?.isCreateAccountOtpScreen
    ) {
      setContactFormValuesInSS({ ...updatedContactFormValues });
    }
  }

  onOTPVerify = (values) => {
    const { onSubmit, existingUserResponse } = this.props;
    const { rememberMe, emailAddress } = existingUserResponse;

    const payload = { ...values, emailAddress, rememberMe };
    onSubmit(payload);
  };

  generateOTP = (payload) => {
    const { onGenerateOTP, otpMessageThreshold, loginErrorMessage } = this.props;
    onGenerateOTP({ isResend: true, ...payload });
    if (!loginErrorMessage && loginErrorMessage === '') {
      this.setState({ newCodeSent: true });
    }
    const timer = setTimeout(() => {
      this.setState({ newCodeSent: false });
      clearTimeout(timer);
    }, otpMessageThreshold);
  };

  handleSubmitForm(payload) {
    const { createAccountAction } = this.props;
    this.handleSubmitCalled = true;
    createAccountAction(payload);
  }

  renderHeaderBrands = () => {
    return (
      <>
        {!isCanada() ? (
          <BodyCopy component="div" textAlign="center" className="elem-mt-LRG elem-mb-SM">
            <Image
              src={getIconPath('header__brand-tab-quad')}
              alt="pjp brand logo"
              height="32px"
              width="300xpx"
            />
          </BodyCopy>
        ) : (
          <BodyCopy component="div" textAlign="center" className="elem-mt-REG elem-mb-SM">
            <Image
              src={getIconPath('header__brand-tab-tcp')}
              alt="tcp brand logo"
              height="24px"
              width="70px"
              className="elem-mr-MED"
            />
            <Image
              src={getIconPath('header__brand-tab-gym')}
              alt="gym brand logo"
              height="27px"
              width="72px"
              className="elem-mr-MED"
            />
          </BodyCopy>
        )}
      </>
    );
  };

  renderTopSection = (emailIsNewRegisteredFlow, lblcreateAcntPointRwd) => {
    const headerLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACCESSIBILITY_LABELS}.${myPlaceRewards}`,
      GlobalAccessibilityLabels
    ).split(' ');
    const {
      lbl_login_create_account_easy_shopping_ca_part_1: lblEasyShoppingPart1,
      lbl_login_create_account_easy_shopping_ca_part_2: lblEasyShoppingPart2,
      lbl_login_create_account_earn_points: lblEarnPoints,
      lbl_login_every_purchase: lblEveryPurchase,
    } = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
    return (
      <>
        <BodyCopy fontSize="fs26" fontFamily="secondary" textAlign="center" fontWeight="extrabold">
          {getLabelFromCopyOrFromTranslation(
            `${GLOBAL_GENERIC_LABELS}.${lblCreateAccount}`,
            GlobalGenericLabels
          )}
        </BodyCopy>
        {this.renderHeaderBrands()}
        {isCanada() ? (
          <BodyCopy textAlign="center" component="div">
            <BodyCopy
              fontSize="fs13"
              fontFamily="secondary"
              textAlign="center"
              fontWeight="bold"
              className="create_earn_points"
            >
              {`${lblEasyShoppingPart1} `}
            </BodyCopy>
            <BodyCopy
              fontSize="fs13"
              fontFamily="secondary"
              textAlign="center"
              fontWeight="bold"
              className="elem-pl-XXXS create_earn_points"
            >
              {`${lblEasyShoppingPart2}`}
            </BodyCopy>
          </BodyCopy>
        ) : (
          <BodyCopy textAlign="center" component="div">
            <BodyCopy textAlign="center" component="div">
              <BodyCopy
                fontSize="fs13"
                fontFamily="secondary"
                textAlign="center"
                fontWeight="bold"
                className="create_earn_points"
              >
                {lblEarnPoints}
              </BodyCopy>
              <BodyCopy
                component="span"
                fontSize="fs13"
                fontFamily="secondary"
                textAlign="center"
                fontWeight="bold"
                className="create-account  elem-pl-XXXS"
              >
                {lblEveryPurchase}
                <BodyCopy component="span" className="my-place-rewards elem-ml-XXXS line-break">
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontSize="fs13"
                    className="text-style-1 elem-ml-XXM"
                    fontFamily="secondary"
                  >
                    {headerLabel[0] ? `${headerLabel[0]} ` : ''}
                  </BodyCopy>
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontSize="fs13"
                    className="text-style-2"
                    fontFamily="secondary"
                  >
                    {headerLabel[1] ? `${headerLabel[1]} ` : ''}
                  </BodyCopy>
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontSize="fs13"
                    className="text-style-3"
                    fontFamily="secondary"
                  >
                    {headerLabel[2] ? `${headerLabel[2]} ` : ''}
                  </BodyCopy>
                  <BodyCopy
                    className="elem-mt-XXS create-reward-points"
                    fontSize="fs13"
                    fontFamily="secondary"
                    textAlign="center"
                    fontWeight="bold"
                  >
                    {lblcreateAcntPointRwd}
                  </BodyCopy>
                </BodyCopy>
              </BodyCopy>
            </BodyCopy>
          </BodyCopy>
        )}
        <BodyCopy component="div" textAlign="center" className="underline" />

        {emailIsNewRegisteredFlow && (
          <>
            <BodyCopy
              textAlign="center"
              fontWeight="bold"
              fontSize="fs13"
              fontFamily="secondary"
              className="elem-mt-XL"
            >
              {emailIsNewRegisteredFlow}
            </BodyCopy>
          </>
        )}
      </>
    );
  };

  // eslint-disable-next-line complexity
  render() {
    const { newCodeSent } = this.state;

    const otpSectionProps = {
      ...this.props,
      newCodeSent,
      onSubmit: this.onOTPVerify,
      generateOTP: this.generateOTP,
    };

    const {
      className,
      isIAgreeChecked,
      hideShowPwd,
      confirmHideShowPwd,
      error,
      onAlreadyHaveAnAccountClick,
      isUserLoggedIn,
      userplccCardNumber,
      userplccCardId,
      existingUserInformation = {},
      fullPageView,
      formSubmissionTriggered,
      showSkeleton,
      isLoading,
      isNewRegisteredFlow,
      isSafari,
      isBonusPointsEventMessagingEnabled,
      isShowOTPInputScreen,
      isFromCheckout,
      routeForBagCheckout,
      saveExistingUserResponse,
      isOTpScreenEnabled,
      userEmail,
      existingUserResponse,
      loginErrorMessage,
      resetLoginState,
      otpToken,
      setIsFromCreateAccount,
      setLoader,
      showRecaptcha,
      setOnSubmitLoader,
      setOffSubmitLoader,
      isInternationalPhoneNumberEnabled,
      dispatchFormFieldChange,
      loginFlowUXEnhancementEnabled,
      isUpdatedCanadaTermsAndConditions,
      isHideLoginLoader,
    } = this.props;
    let emailIsNewRegisteredFlow = '';
    const {
      firstName = '',
      lastName = '',
      zipCode: noCountryZip = '',
      emailAddress = '',
      phoneNumber = '',
    } = existingUserInformation;
    if (isNewRegisteredFlow) {
      const contactFormValuesFromSS = getContactFormValuesFromSS();
      emailIsNewRegisteredFlow = contactFormValuesFromSS.emailAddress;
    }
    const emailAddressLowerCased = emailAddress.toLowerCase();
    const showSkeletonUI = !this.handleSubmitCalled && showSkeleton;
    const registrationLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_REGISTRATION_LABELS,
      GlobalRegistrationLabels
    );
    const {
      lbl_createAccount_succcessMsg: lblCreateAcntSuccessMsg,
      lbl_createAccount_pointReward: lblcreateAcntPointRwd,
    } = registrationLabels;

    const newRegisteredFlow =
      isNewRegisteredFlow || isBonusPointsEventMessagingEnabled ? 'newRegisteredFlow' : '';
    return (
      <div className={className} ref={this.parentRef}>
        <div className={`parent-wrapper ${newRegisteredFlow}`}>
          {showSkeletonUI && <CreateAccountSkeleton />}
          {!loginFlowUXEnhancementEnabled &&
            !showSkeletonUI &&
            !isShowOTPInputScreen &&
            this.renderTopSection(emailIsNewRegisteredFlow, lblcreateAcntPointRwd)}
          {error && !isUserLoggedIn && (
            <div className="elem-pl-LRG elem-pr-LRG elem-pt-LRG">
              <BodyCopy
                fontFamily={['secondary']}
                fontWeight="semibold"
                fontSize="fs12"
                color="error"
              >
                {renderLabel(registrationLabels[error], `${error}`)}
              </BodyCopy>
            </div>
          )}

          {isUserLoggedIn && formSubmissionTriggered && (
            <div className="elem-pl-LRG elem-pr-LRG elem-pt-LRG">
              <Notification
                status="success"
                colSize={{ large: 12, medium: 8, small: 6 }}
                message={lblCreateAcntSuccessMsg}
              />
            </div>
          )}
          {!showSkeletonUI && !isShowOTPInputScreen && (
            <CreateAccountFormV2
              className={className}
              onSubmit={this.handleSubmitForm}
              isIAgreeChecked={isIAgreeChecked}
              hideShowPwd={hideShowPwd}
              initialValues={{
                rememberMe: true,
                emailSubscription: false,
                plcc_checkbox: !isCanada(),
                firstName,
                lastName,
                noCountryZip,
                emailAddress: isNewRegisteredFlow
                  ? emailIsNewRegisteredFlow
                  : emailAddressLowerCased,
                phoneNumber,
                confirmEmailAddress: emailAddressLowerCased,
              }}
              confirmHideShowPwd={confirmHideShowPwd}
              onAlreadyHaveAnAccountClick={onAlreadyHaveAnAccountClick}
              tooltipContent={<PasswordRequirement />}
              userplccCardNumber={userplccCardNumber}
              userplccCardId={userplccCardId}
              fullPageView={fullPageView}
              isUserLoggedIn={isUserLoggedIn}
              isLoading={isLoading}
              isSafari={isSafari}
              isNewRegisteredFlow={isNewRegisteredFlow}
              isBonusPointsEventMessagingEnabled={isBonusPointsEventMessagingEnabled}
              formErrorMessage={this.formValidationErrorLabels}
              setOnSubmitLoader={setOnSubmitLoader}
              setOffSubmitLoader={setOffSubmitLoader}
              isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
              dispatchFormFieldChange={dispatchFormFieldChange}
              emailIsNewRegisteredFlow={emailIsNewRegisteredFlow}
              loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
              isUpdatedCanadaTermsAndConditions={isUpdatedCanadaTermsAndConditions}
            />
          )}
          {isShowOTPInputScreen &&
            isOTpScreenEnabled &&
            !error &&
            existingUserResponse?.emailAddress && (
              <CreateAccountOtpForm
                emailAddress={
                  emailIsNewRegisteredFlow ||
                  userEmail ||
                  existingUserResponse?.emailAddress ||
                  emailAddressLowerCased
                }
                isFromCheckout={isFromCheckout}
                routeForBagCheckout={routeForBagCheckout}
                saveExistingUserResponse={saveExistingUserResponse}
                loginErrorMessage={loginErrorMessage}
                resetLoginState={resetLoginState}
                otpToken={otpToken}
                setIsFromCreateAccount={setIsFromCreateAccount}
                setLoader={setLoader}
                showRecaptcha={showRecaptcha}
                isHideLoginLoader={isHideLoginLoader}
                {...otpSectionProps}
              />
            )}
        </div>
      </div>
    );
  }
}

CreateAccounPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  otpMessageThreshold: PropTypes.number,
  showRecaptcha: PropTypes.bool,
  loginErrorMessage: PropTypes.string,
  rememberUser: PropTypes.bool,
};

CreateAccounPage.defaultProps = {
  showRecaptcha: true,
  errorMessage: '',
  otpMessageThreshold: 5000,
  loginErrorMessage: '',
  rememberUser: true,
};

export default withStyles(CreateAccounPage, styles);
export { CreateAccounPage as CreateAccounPageVanilla };
